export default __webpack_public_path__ + "static/media/sr-95.571f0b04.mp3";